import React from 'react';
import prival_02 from '../../../images/perm/prival_02.jpg';
import prival_03 from '../../../images/perm/prival_03.jpg';
import cave_01 from '../../../images/perm/cave_01.jpg';
import kungur_01 from '../../../images/perm/kungur_01.jpg';
import kungur_02 from '../../../images/perm/kungur_02.jpg';
import kungur_03 from '../../../images/perm/kungur_03.jpg';
import kungur_04 from '../../../images/perm/kungur_04.jpg';
import kungur_05 from '../../../images/perm/kungur_05.jpg';
import kungur_06 from '../../../images/perm/kungur_06.jpg';
import kungur_07 from '../../../images/perm/kungur_07_vert.jpg';
import kungur_08 from '../../../images/perm/kungur_08.jpg';
import kungur_09 from '../../../images/perm/kungur_09_vert.jpg';
import kungur_10 from '../../../images/perm/kungur_10.jpg';
import kungur_11 from '../../../images/perm/kungur_11.jpg';
import kungur_12 from '../../../images/perm/kungur_12.jpg';
import usva_01 from '../../../images/perm/usva_01.jpg';
import usva_02 from '../../../images/perm/usva_02.jpg';
import usva_03 from '../../../images/perm/usva_03.jpg';
import usva_04 from '../../../images/perm/usva_04.jpg';
import usva_05 from '../../../images/perm/usva_05.jpg';
import usva_06 from '../../../images/perm/usva_06.jpg';
import usva_07 from '../../../images/perm/usva_07.jpg';
import usva_08 from '../../../images/perm/usva_08.jpg';
import usva_09 from '../../../images/perm/usva_09.jpg';
import usva_10 from '../../../images/perm/usva_10.jpg';
import perm_01 from '../../../images/perm/perm_01.jpg';
import perm_02 from '../../../images/perm/perm_02.jpg';
import perm_03 from '../../../images/perm/perm_03.jpg';
import perm_04 from '../../../images/perm/perm_04.jpg';



const Perm = () => {
    return (
        <div className="container">
            <div className="row">
                <div className="col-12">

                    <p>
                    В&nbsp;июле 2025 года добрались до&nbsp;Пермского края. Вообще то&nbsp;изначально хотели в&nbsp;первый день добраться до&nbsp;областной столицы. Сделали привал по&nbsp;дороге.
                    </p>

                   
                    <div id="perm" className="carousel slide" data-bs-ride="true">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#perm" data-bs-slide-to="0"
                                    className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#perm" data-bs-slide-to="1"
                                    aria-label="Slide 2"></button>
                        </div>

                        <div className="carousel-inner travel__img">
                            <div className="carousel-item active">
                                <img src={prival_02} className="d-block w-100" alt="Пермский край"/>
                            </div>
                            <div className="carousel-item">
                                <img src={prival_03} className="d-block w-100" alt="Пермский край"/>
                            </div>
                        </div>
                        
                        <button className="carousel-control-prev" type="button" data-bs-target="#perm"
                                data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>

                        <button className="carousel-control-next" type="button" data-bs-target="#perm"
                                data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>

                    <p>
                    По&nbsp;пути выяснилось, что в&nbsp;Перьми в&nbsp;этот день почти нет адекватных вариантов размещения. Да, такое бывает... Поэтому забронировали жильё в&nbsp;Кунгуре. Заодно заехали к&nbsp;пещере.
                    </p>

                    <p>
                    Государство изъяло права у&nbsp;частного недропользователя, занимавшегося поддержанием ледяной пещеры и&nbsp;развитием её&nbsp;территории. Поэтому посещение пещеры было приостановлено.
                    </p>

                    <img src={cave_01} className="img-fluid travel__img" loading="lazy" alt="Кунгурская ледяная пещера"/>

                    <p>
                    Далее едем в&nbsp;годо Кунгур заселяться. После гуляем по&nbsp;городу. Очень уютно.
                    </p>

                    <div id="kungur" className="carousel slide" data-bs-ride="true">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#kungur" data-bs-slide-to="0"
                                    className="active" aria-current="true" aria-label="Slide 1"></button>
                                    
                            <button type="button" data-bs-target="#kungur" data-bs-slide-to="1"
                                    aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#kungur" data-bs-slide-to="2"
                                    aria-label="Slide 3"></button>
                            <button type="button" data-bs-target="#kungur" data-bs-slide-to="3"
                                    aria-label="Slide 4"></button>
                            <button type="button" data-bs-target="#kungur" data-bs-slide-to="4"
                                    aria-label="Slide 5"></button>
                            <button type="button" data-bs-target="#kungur" data-bs-slide-to="5"
                                    aria-label="Slide 6"></button>
                            <button type="button" data-bs-target="#kungur" data-bs-slide-to="6"
                                    aria-label="Slide 7"></button>
                            <button type="button" data-bs-target="#kungur" data-bs-slide-to="7"
                                    aria-label="Slide 8"></button>
                            <button type="button" data-bs-target="#kungur" data-bs-slide-to="8"
                                    aria-label="Slide 9"></button>
                            <button type="button" data-bs-target="#kungur" data-bs-slide-to="9"
                                    aria-label="Slide 10"></button>
                        </div>

                        <div className="carousel-inner travel__img">
                            <div className="carousel-item active">
                                <img src={kungur_01} className="d-block w-100" alt="Кунгур"/>
                            </div>
                            <div className="carousel-item">
                                <img src={kungur_02} className="d-block w-100" alt="Кунгур"/>
                            </div>
                            <div className="carousel-item">
                                <img src={kungur_03} className="d-block w-100" alt="Кунгур"/>
                            </div>
                            <div className="carousel-item">
                                <img src={kungur_04} className="d-block w-100" alt="Кунгур"/>
                            </div>
                            <div className="carousel-item">
                                <img src={kungur_05} className="d-block w-100" alt="Кунгур"/>
                            </div>
                            <div className="carousel-item">
                                <img src={kungur_06} className="d-block w-100" alt="Кунгур"/>
                            </div>
                            <div className="carousel-item">
                                <img src={kungur_08} className="d-block w-100" alt="Кунгур"/>
                            </div>
                            <div className="carousel-item">
                                <img src={kungur_10} className="d-block w-100" alt="Кунгур"/>
                            </div>
                            <div className="carousel-item">
                                <img src={kungur_11} className="d-block w-100" alt="Кунгур"/>
                            </div>
                            <div className="carousel-item">
                                <img src={kungur_12} className="d-block w-100" alt="Кунгур"/>
                            </div>
                        </div>

                        <button className="carousel-control-prev" type="button" data-bs-target="#kungur"
                                data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#kungur"
                                data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>

                    <p>
                    Город и&nbsp;в&nbsp;правду, оставил хорошие впечатления.
                    </p>


                    <div id="kungur_01" className="carousel slide" data-bs-ride="true">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#kungur_01" data-bs-slide-to="0"
                                    className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#kungur_01" data-bs-slide-to="1"
                                    aria-label="Slide 2"></button>
                        </div>

                        <div className="carousel-inner travel__img">
                            <div className="carousel-item active">
                                <img src={kungur_07} className="d-block w-100" alt="Кунгур"/>
                            </div>
                            <div className="carousel-item">
                                <img src={kungur_09} className="d-block w-100" alt="Кунгур"/>
                            </div>
                        </div>
                        
                        <button className="carousel-control-prev" type="button" data-bs-target="#kungur_01"
                                data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>

                        <button className="carousel-control-next" type="button" data-bs-target="#kungur_01"
                                data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>

                    <p>
                    Чтобы дождаться адекватных вариантов в&nbsp;Перьми, сначала едем на&nbsp;север в&nbsp;Усьву. Селение это, практически полностью превратилось в&nbsp;туристическое и&nbsp;дачное.
                    </p>

                    <div id="usva_01" className="carousel slide" data-bs-ride="true">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#usva_01" data-bs-slide-to="0"
                                    className="active" aria-current="true" aria-label="Slide 1"></button>
                                    
                            <button type="button" data-bs-target="#usva_01" data-bs-slide-to="1"
                                    aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#usva_01" data-bs-slide-to="2"
                                    aria-label="Slide 3"></button>
                            <button type="button" data-bs-target="#usva_01" data-bs-slide-to="3"
                                    aria-label="Slide 4"></button>
                        </div>

                        <div className="carousel-inner travel__img">
                            <div className="carousel-item active">
                                <img src={usva_04} className="d-block w-100" alt="Усьва"/>
                            </div>
                            <div className="carousel-item">
                                <img src={usva_05} className="d-block w-100" alt="Усьва"/>
                            </div>
                            <div className="carousel-item">
                                <img src={usva_06} className="d-block w-100" alt="Усьва"/>
                            </div>
                            <div className="carousel-item">
                                <img src={usva_07} className="d-block w-100" alt="Усьва"/>
                            </div>
                        </div>

                        <button className="carousel-control-prev" type="button" data-bs-target="#usva_01"
                                data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#usva_01"
                                data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>

                    <p>
                    На&nbsp;следующее утро отправляемся на&nbsp;Усьвинские столбы. Добираемся от&nbsp;села до&nbsp;места подъёма на&nbsp;моторке. Потом подъём в&nbsp;гору. Красиво.
                    </p>

                    <div id="usva_02" className="carousel slide" data-bs-ride="true">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#usva_02" data-bs-slide-to="0"
                                    className="active" aria-current="true" aria-label="Slide 1"></button>
                                    
                            <button type="button" data-bs-target="#usva_02" data-bs-slide-to="1"
                                    aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#usva_02" data-bs-slide-to="2"
                                    aria-label="Slide 3"></button>
                            <button type="button" data-bs-target="#usva_02" data-bs-slide-to="3"
                                    aria-label="Slide 4"></button>
                            <button type="button" data-bs-target="#usva_02" data-bs-slide-to="4"
                                    aria-label="Slide 5"></button>
                            <button type="button" data-bs-target="#usva_02" data-bs-slide-to="5"
                                    aria-label="Slide 6"></button>
                        </div>

                        <div className="carousel-inner travel__img">
                            <div className="carousel-item active">
                                <img src={usva_08} className="d-block w-100" alt="Усьвинские столбы"/>
                            </div>
                            <div className="carousel-item">
                                <img src={usva_01} className="d-block w-100" alt="Усьвинские столбы"/>
                            </div>
                            <div className="carousel-item">
                                <img src={usva_02} className="d-block w-100" alt="Усьвинские столбы"/>
                            </div>
                            <div className="carousel-item">
                                <img src={usva_03} className="d-block w-100" alt="Усьвинские столбы"/>
                            </div>
                            <div className="carousel-item">
                                <img src={usva_09} className="d-block w-100" alt="Усьвинские столбы"/>
                            </div>
                            <div className="carousel-item">
                                <img src={usva_10} className="d-block w-100" alt="Усьвинские столбы"/>
                            </div>
                        </div>

                        <button className="carousel-control-prev" type="button" data-bs-target="#usva_02"
                                data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#usva_02"
                                data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>

                    <p>
                    После этого, наконец едем в&nbsp;город Пермь, где стало посвободней с&nbsp;жильём. Последний раз я&nbsp;был здесь в&nbsp;середине 90-х, и&nbsp;не&nbsp;помню вообще ничего. Город кажется вполне ухоженным и&nbsp;симпатичным. Большая судоходная река, всегда придаёт городу колорита. Инфраструктура в&nbsp;мелочах выглядит как-будто лучше чем в&nbsp;Челябинске.
                    </p>

                    <div id="perm_city" className="carousel slide" data-bs-ride="true">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#perm_city" data-bs-slide-to="0"
                                    className="active" aria-current="true" aria-label="Slide 1"></button>
                                    
                            <button type="button" data-bs-target="#perm_city" data-bs-slide-to="1"
                                    aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#perm_city" data-bs-slide-to="2"
                                    aria-label="Slide 3"></button>
                            <button type="button" data-bs-target="#perm_city" data-bs-slide-to="3"
                                    aria-label="Slide 4"></button>
                        </div>

                        <div className="carousel-inner travel__img">
                            <div className="carousel-item active">
                                <img src={perm_01} className="d-block w-100" alt="Пермь"/>
                            </div>
                            <div className="carousel-item">
                                <img src={perm_02} className="d-block w-100" alt="Пермь"/>
                            </div>
                            <div className="carousel-item">
                                <img src={perm_03} className="d-block w-100" alt="Пермь"/>
                            </div>
                            <div className="carousel-item">
                                <img src={perm_04} className="d-block w-100" alt="Пермь"/>
                            </div>
                        </div>

                        <button className="carousel-control-prev" type="button" data-bs-target="#perm_city"
                                data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#perm_city"
                                data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>

                    <p>
                    Возвращаясь в&nbsp;Челябинск понимаешь, что это действительно Южный Урал. Растительность вокруг меняется на&nbsp;более лиственную и&nbsp;низкую и&nbsp;даже воздух здесь более душный.
                    </p>
                    
                    
                    
                    <br />

                    

                </div>
            </div>
        </div>
    );
};

export default Perm;